// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".real-tex-load__iframe{display:block;width:100%;min-height:300px}", "",{"version":3,"sources":["webpack://./src/main/components/RealTeXLoad.scss"],"names":[],"mappings":"AACA,uBACE,aAAA,CACA,UAAA,CACA,gBAAA","sourcesContent":["\n.real-tex-load__iframe {\n  display: block;\n  width: 100%;\n  min-height: 300px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
